import { DutyLogEntity } from 'src/store/duty-log/duty-log.model';

export class DutyLogEntryViewModel implements DutyLogEntity {
  public id: string;
  public employeeId: string;
  public baseId?: string | undefined;
  public dispatchBaseCompanyId?: string | undefined;
  public aircraftId?: string | undefined;
  public dutyPeriodStartTime?: Date;
  public dutyPeriodEndTime?: Date;
  public isActive: boolean;
  public updatedAt?: Date;
  public comments?: string;
  public justification?: string;
  constructor(dutyLog: DutyLogEntity) {
    Object.assign(this, dutyLog);
  }
}
